<template>
  <div>
    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label">Name</label>
      </div>
      <div class="control is-grouped">
        <p class="control is-expanded">
          <input v-validate="'required|max:255'"
                 :class="{'is-danger': errors.has('name') }" name="name"
                 v-model="body.name" class="input" type="text" placeholder="Enter name">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
      </div>
    </div>

    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label">Phone</label>
      </div>
      <div class="control is-grouped">
        <p class="control is-expanded">
          <input v-validate="'required|max:255'"
                 :class="{'is-danger': errors.has('phone') }"
                 name="phone" v-model="body.phone" class="input" type="text"
                 placeholder="Enter phone">
          <span v-show="errors.has('phone')"
                class="help is-danger">{{ errors.first('phone') }}</span>
        </p>
      </div>
    </div>
    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label">Gender</label>
      </div>
      <div class="control is-grouped">
        <div class="select is-fullwidth">
          <select v-model="body.gender">
            <option value="0">Female</option>
            <option value="1">Male</option>
          </select>
        </div>
      </div>
    </div>

    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label"></label>
      </div>
      <div class="control">
        <a @click="cancel" class="button is-link">Cancel</a>
        <save-button @click="save"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        body: {
          gender: this.data.gender ? this.data.gender : 1,
          name: this.data.name ? this.data.name : '',
          phone: this.data.phone ? this.data.phone : ''
        }
      }
    },
    methods: {
      cancel() {
        this.$emit('cancel');
      },
      save() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$emit('save', this.body);
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>